import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const VideoUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const rawAppId = params.get('applicationId');
  const applicationId = rawAppId && rawAppId !== 'null' ? rawAppId : null;
  const rawCustomerId = params.get('customerId');
  const customerId = rawCustomerId && rawCustomerId !== 'null' ? rawCustomerId : null;

  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const inputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setVideoFile(file);
    setVideoPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!videoFile || !customerId) {
      navigate(`/ProductTypes?applicationId=${applicationId}&customerId=${customerId}`);
      return;
    }
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', videoFile);
      formData.append('customerId', Number(customerId));
      await api.post(`${base_url}/api/s3/uploadVideo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      navigate(`/ProductTypes?applicationId=${applicationId}&customerId=${customerId}`);
    } catch {
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="Video KYC" backPath={`/DocumentUpload?applicationId=${applicationId}&customerId=${customerId}`} />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <div className="app-card">
          <p className="section-title">Video KYC</p>
          <p style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
            Record a short video or upload an existing one for KYC verification.
          </p>

          <input
            ref={inputRef}
            type="file"
            accept="video/*"
            id="upload-video"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />

          <label
            htmlFor="upload-video"
            style={{
              display: 'inline-block', padding: '10px 20px', borderRadius: 8,
              border: '1.5px solid #1d2e77', color: '#1d2e77', fontWeight: 600,
              fontSize: 14, cursor: 'pointer',
            }}
          >
            {videoFile ? 'Replace Video' : 'Record / Upload Video'}
          </label>

          {videoPreview && (
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <video
                src={videoPreview}
                controls
                style={{ maxWidth: '100%', borderRadius: 8, maxHeight: 260 }}
              />
              <p style={{ fontSize: 12, color: '#11c232', fontWeight: 600, marginTop: 6 }}>
                Video selected
              </p>
            </div>
          )}
        </div>

        <button className="btn-primary-app" onClick={handleUpload} disabled={isLoading}>
          {isLoading ? 'Uploading...' : videoFile ? 'Upload & Continue' : 'Skip & Continue'}
        </button>
      </div>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Error uploading video. Please try again.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={() => setErrorModal(false)}>Close</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VideoUpload;
